import { render, staticRenderFns } from "./LoginSetting.vue?vue&type=template&id=52237574"
import script from "./LoginSetting.vue?vue&type=script&lang=js"
export * from "./LoginSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports